import MetConstants from "../datosVars/metConstants";
import ArrayUtils from "../../utils/arraysUtils";
import OrdenListaObjetosConId from "./../tipos/ordenListaObjetosConId";

const TIPO_ORDEN_ESTACIONES_GERENCIA_TIPOESTACION_NOMBRE = 2;
const TIPO_ORDEN_ESTACIONES_NOMBRE = 3;

const TIPO_ORDEN_DEFECTO = TIPO_ORDEN_ESTACIONES_GERENCIA_TIPOESTACION_NOMBRE;

class OrdenEstaciones extends OrdenListaObjetosConId {
  constructor(tipo, idsOrdenCustom, ordenGerencias) {
    super(tipo, idsOrdenCustom);
    // Si el tipo de orden no esta definido tomo el definido por defecto
    this._tipo = this._tipo ? tipo : TIPO_ORDEN_DEFECTO;
    this._gerencias = ordenGerencias
      ? ordenGerencias
      : MetConstants.gerenciasOrdenDefecto;
  }

  equals(orden) {
    return (super.equals(orden) &&
      ArrayUtils.equalsContents(orden.gerencias, this.gerencias)
    );
  }

  get gerencias() {
    return this._gerencias;
  }
}

function createOrdenEstacionesCustom() {
  return new OrdenEstaciones();
}

export {
  OrdenEstaciones as default,
  createOrdenEstacionesCustom,
  TIPO_ORDEN_ESTACIONES_GERENCIA_TIPOESTACION_NOMBRE,
  TIPO_ORDEN_ESTACIONES_NOMBRE,
};
